// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mainNavigationStyles } from "@ces/Overrides/Widgets/Header/MainNavigation";
import ArrowDown from "@ces/XDL/Icons/ArrowDown";
import LinkArrowRight from "@ces/XDL/Icons/LinkArrowRight";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        color: ${color("common.background")};
        display: flex;
        gap: 32px;
        padding: 0;
        &&&&:not(:disabled):visited {
            & ${TypographyStyle} {
                color: ${color("text")};
            }
        }
    `,
};

mainNavigationStyles.menuItemTypography = {
    color: "text",
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    weight: fontConfig.weight.bold,
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        display: flex;
        align-items: center;
        padding: 0;
        ${IconWrapper} {
            color: ${color("text.link")};
            margin: 0;
        }

        &&&&:not(:disabled):visited {
            & ${TypographyStyle} {
                color: ${color("text")};
            }
        }

        & + .mega-menu {
            transform: translateY(11px);
        }
    `,
};

mainNavigationStyles.itemWrapper = {};

mainNavigationStyles.cascadingMenu = {
    cssOverrides: {
        menu: css`
            padding-bottom: 6px;
        `,
    },
    viewAllLink: {
        typographyProps: {
            size: fontConfig.fontSize.small,
            lineHeight: fontConfig.lineHeight.small,
            weight: fontConfig.weight.bold,
        },
        icon: {
            iconProps: {
                src: LinkArrowRight,
                size: 14,
            },
            position: "right",
        },
        css: css`
            padding-left: 8px;
            margin-bottom: 16px;
            margin-top: 10px;
        `,
    },
};

mainNavigationStyles.menuItemIcon = {
    src: ArrowDown,
    size: 13,
    css: css`
        width: 9px;
        margin: 0;
    `,
};
